import { SetDraftResurveyAllRequestSchema, SetDraftResurveyAllResponseSchema } from './set-draft-resurvey-all.schema';
/**
 * Set Draft Re-survey (All Steps) Endpoint Contract
 * Flags or clears the survey re-request on every survey-eligible draft step.
 */ export const setDraftResurveyAllContract = {
    method: 'PATCH',
    path: '/api/v2/process/:processId/draft/resurvey-all',
    description: 'Flag or clear survey re-request on every survey-eligible draft step (applied on publish)',
    requestSchema: SetDraftResurveyAllRequestSchema,
    responseSchema: SetDraftResurveyAllResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - cannot edit this process',
            404: 'Draft not found'
        }
    }
};

//# sourceMappingURL=set-draft-resurvey-all.contract.js.map